<template>
  <div class="component-page-header">
    <div class="container-xxl">
      <breadcrumbs class="mb-7" />
      <slot name="custom-header">
        <div
          class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-5"
        >
          <div>
            <h2 class="mb-2" v-if="title">{{ title }}</h2>
            <h4 class="text-neutral-400" v-if="subtitle">{{ subtitle }}</h4>
          </div>
          <div>
            <slot />
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "./Breadcrumbs";
export default {
  props: {
    title: {
      type: String,
      default: "Title"
    },
    subtitle: {
      type: String,
      default: "Subtitle"
    }
  },
  components: { Breadcrumbs }
};
</script>
<style lang="scss" scoped>
.component-page-header {
  padding: 24px 0;
  background-color: var(--bg-5);

  .default-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      margin-bottom: 4px;
    }
  }

  @media screen and (max-width: 767px) {
    padding: 24px 0;
    .default-header {
      h2 {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
